export default __webpack_public_path__ + "static/media/volume.a9d8f660.svg";